import * as React from 'react';

import { ICON_NAME, ICON_NAME_TO_ICON_MAP } from './icon.constants';
import './icon.styles.less';

export function Icon(props: IIconProps): JSX.Element {
    const glyph: string = ICON_NAME_TO_ICON_MAP[props.name];
    return (
        <div className="sitegen-icon" {...props} dangerouslySetInnerHTML={{ __html: glyph }} />
    );
}

export interface IIconProps extends React.ComponentPropsWithoutRef<'div'> {
    readonly name: ICON_NAME;
}
